import { Testimonials } from '@frontendmentorio/design-system-v2';

export default function Testimonials2() {
  return (
    <div className="px-5 tablet:pb-6">
      <Testimonials>
        <Testimonials.Card
          avatar="/static/images/pro-avatar-vanza.webp"
          name="Vanza"
          title="@vanzasetia"
        >
          Frontend Mentor’s design files let me build with accuracy, not
          guesswork. Pro features like private solutions and unlimited
          screenshots helped me polish my projects, and the premium challenges
          directly led to interview calls from my applications.
        </Testimonials.Card>

        <Testimonials.Card
          avatar="/static/images/pro-avatar-valter.webp"
          name="Valter"
          title="@Valvrauu"
        >
          Frontend Mentor showed me the true value of practice over theory. The
          Pro subscription and Figma designs made it easy to refine my work, and
          unlimited solution screenshots helped me keep tweaking my solutions.
        </Testimonials.Card>
      </Testimonials>
    </div>
  );
}
